/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MomentOfConsume extends DaoModel {
  constructor(guid, name, description, point_of_sale) {
    super(guid);
    this.name = name || '';
    this.description = description || '';
    this.point_of_sale = point_of_sale;
  }

  static toInstance(props = {}) {
    return new MomentOfConsume(props.guid, props.name, props.description, props.point_of_sale);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      description: this.description,
      point_of_sale: this.point_of_sale
    };
  }
}
